import { Form, InputGroup } from 'react-bootstrap';

// Ô nhập giờ luôn 24 giờ. `<input type='time'>` gốc của trình duyệt hiện
// AM/PM theo ngôn ngữ của máy, nên dùng hai ô chọn giờ/phút thay thế.
// value / onChange giữ nguyên dạng "HH:mm" như ô time cũ.
const GIO = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'));

const NhapGio24h = ({ value, onChange, nhan, buocPhut = 5 }) => {
  const [gio = '00', phut = '00'] = String(value || '00:00').split(':');
  const dsPhut = Array.from({ length: Math.ceil(60 / buocPhut) }, (_, i) =>
    String(i * buocPhut).padStart(2, '0'),
  );
  // Giá trị cũ có phút lẻ (ngoài bước) vẫn phải hiện đúng, không bị đổi ngầm.
  if (!dsPhut.includes(phut)) dsPhut.push(phut);
  dsPhut.sort();

  return (
    <InputGroup>
      <Form.Select
        aria-label={`${nhan} - giờ`}
        value={gio}
        onChange={(e) => onChange(`${e.target.value}:${phut}`)}
      >
        {GIO.map((g) => (
          <option key={g} value={g}>
            {g}
          </option>
        ))}
      </Form.Select>
      <InputGroup.Text>:</InputGroup.Text>
      <Form.Select
        aria-label={`${nhan} - phút`}
        value={phut}
        onChange={(e) => onChange(`${gio}:${e.target.value}`)}
      >
        {dsPhut.map((m) => (
          <option key={m} value={m}>
            {m}
          </option>
        ))}
      </Form.Select>
    </InputGroup>
  );
};

export default NhapGio24h;
